var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreaterthan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.161167 12.0223C0.0649194 11.8298 0.102647 11.5974 0.254827 11.4452L4.52145 7.17856C4.71671 6.98329 4.71671 6.66671 4.52145 6.47145L0.254827 2.20483C0.102647 2.05265 0.0649195 1.82016 0.161167 1.62767L0.664762 0.620476C0.817387 0.315226 1.22421 0.249209 1.46553 0.490529L7.44645 6.47145C7.64171 6.66671 7.64171 6.98329 7.44645 7.17856L1.46553 13.1595C1.22421 13.4008 0.817387 13.3348 0.664762 13.0295L0.161167 12.0223Z",
    fill: "#824ED2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterthan);
export default __webpack_public_path__ + "static/media/greaterthan.0247dc7347b093d038614d54f8b7baae.svg";
export { ForwardRef as ReactComponent };